// Anything but 'loan' is cash, the one test every scenarioType gate on this screen makes.
export function isLoanScenario(scenarioType) {
  return scenarioType === 'loan'
}
